import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ListVisit from "../../../containers/modules/sales/visit-schedule/list";

export default function ListScheduleRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="list-schedule"
      index
      element={
        <AccessControl
          name={"Visit Schedule Show"}
          auth={authUser}
          component={() => <ListVisit />}
        />
      }
    />
  );
}
